import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Constant from '../../Constant'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
class BoatMasterTimeSlotList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    cat: this.props.match.params.boatType,
  }

  componentDidMount() {
    this.getTimeSlot()
  }

  getTimeSlot = async () => {
    var that = this
    this.setState({ isloading: true })
    var cruiseId = this.props.match.params.boatId
    await axios
      .get(Constant.getAPI() + `/slots/list-cruise-time-slot/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ isloading: false })
          that.setState({
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isloading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  changeStatusForAll = async (event, selectedRows, displayData) => {
    var ids = []
    for (let i = 0; i < selectedRows.data.length; i++) {
      if (
        displayData.length &&
        displayData[selectedRows.data[i].dataIndex] &&
        displayData[selectedRows.data[i].dataIndex].data &&
        displayData[selectedRows.data[i].dataIndex].data[0]
      ) {
        ids.push(displayData[selectedRows.data[i].dataIndex].data[0])
      }
    }

    ids.forEach((id) => {
      let temp_data = this.state.Products_data
      let selectedData

      temp_data.forEach((itm) => {
        if (itm.id == id) {
          selectedData = itm
          itm['is_day_of'] = event.target.value
        }
      })

      this.setState({ Products_data: temp_data })

      selectedData['is_day_of'] = event.target.value

      let data = {
        [event.target.name]: event.target.value,
        cruise_booking_date: selectedData?.cruise_booking_date,
        cruise_id: selectedData?.cruise_id,
        slot_from: selectedData?.slot_from,
        slot_to: selectedData?.slot_to,
      }

      axios
        .put(Constant.getAPI() + `/slots/edit-cruise-time-slot`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status) {
            Swal.fire({
              toast: true,
              icon: 'success',
              position: 'top-end',
              title: `TimeSlot Updated Successfully!`,
              showConfirmButton: false,
              timerProgressBar: true,
              timer: 2500,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    })
  }

  changeStatus = async (event, rowData) => {
    let temp_data = this.state.Products_data
    let selectedData

    temp_data.forEach((itm) => {
      if (itm.id == rowData[0]) {
        selectedData = itm
        itm[event.target.name] = event.target.value
      }
    })

    this.setState({ Products_data: temp_data })

    selectedData[event.target.name] = event.target.value

    let data = {
      [event.target.name]: event.target.value,
      cruise_booking_date: selectedData?.cruise_booking_date,
      cruise_id: selectedData?.cruise_id,
      slot_from: selectedData?.slot_from,
      slot_to: selectedData?.slot_to,
    }

    axios
      .put(Constant.getAPI() + `/slots/edit-cruise-time-slot`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: `TimeSlot Updated Successfully!`,
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const isSuperAdmin = localStorage.getItem('user_role') === 'super-admin'
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'cruise_booking_date',
        label: `Booking Date`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'slot_from',
        label: `Start Time`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'slot_to',
        label: 'End Time',
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: 'is_day_of',
        label: 'Day Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_day_of, { rowData }) => {
            if (!isSuperAdmin) {
              return (
                <div>
                  {is_day_of === false ? (
                    <span className="badge badge-pill badge-warning">Open</span>
                  ) : (
                    <span className="badge badge-pill badge-success">Close</span>
                  )}
                </div>
              )
            }
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="is_day_of"
                  className={`form-control`}
                  value={is_day_of}
                  onChange={(event) => this.changeStatus(event, rowData)}
                >
                  <option value="true">Close</option>
                  <option value="false">Open</option>
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={
                    `/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/boat-timeslot-add/` +
                    id
                  }
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <Link
                  to={
                    `/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/boat-available-timeslots/` +
                    id
                  }
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View Boat Details "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
                {/* <span
                                onClick={this.deleteProducts.bind(this, id)}
                                className="m-r-15 text-muted"
                                data-toggle="tooltip"
                                data-placement="top"
                                title=""
                                data-original-title="Delete"
                                >
                                <i className="f-20 icofont icofont-delete-alt text-danger"></i>{" "}
                                </span> */}
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: isSuperAdmin ? 'multiple' : 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
        if (!isSuperAdmin) {
          return null
        }
        return (
          <select
            style={{ width: 150, marginRight: 10 }}
            name="is_day_of"
            className={`form-control`}
            defaultValue=""
            onChange={(event) => this.changeStatusForAll(event, selectedRows, displayData, setSelectedRows)}
          >
            <option
              selected
              value=""
            >
              Select Status
            </option>
            <option value="true">Close</option>
            <option value="false">Open</option>
          </select>
        )
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.props.match.params.boatType} TimeSlot List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/boat-timeslot-add`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i>
                    {this.props.match.params.boatType} TimeSlot Add
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link
                          to={`/viewboat-details/${this.props.match.params.boatType}/${this.props.match.params.boatId}`}
                        >
                          {this.props.match.params.boatType} Details{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">{this.props.match.params.boatType} TimeSlot List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`${this.props.match.params.boatType} TimeSlot List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BoatMasterTimeSlotList
